import { __assign } from "tslib";
import * as deviceFrames from '../constants/deviceFrames';
import { getFrame } from './project';
export function getDocumentHeadProps(state) {
    var _a, _b;
    var _c = state.project, isLoading = _c.isLoading, isBasic = _c.isBasic;
    if (isBasic) {
        return { isBasic: isBasic };
    }
    if (isLoading) {
        return { isLoading: isLoading };
    }
    return __assign(__assign({ projectID: state.project.config.id, projectTitle: state.project.config.name, screenName: (_b = (_a = state.screen) === null || _a === void 0 ? void 0 : _a.currentScreen) === null || _b === void 0 ? void 0 : _b.name }, state.project.config), { viewportFitCover: getFrame(state) === deviceFrames.IPHONE_X });
}
